"use strict";

import axios from "axios";
import { entries, forEach, result } from "lodash";

export default class PpomService {
  constructor() {
    //this.refs = null;
  }
  getRefs(valtheme = "synthetic") {
    console.log("getRefs", valtheme);
    let url = valtheme?"/api/ppom-clean-data-ref/"+valtheme:"/api/ppom-clean-data-ref";
    let prom = new Promise((resolveMe, rejectMe) => {
      axios
        .get(url)
        .then((response) => {
          if (response.data && response.data.length) {
            let refs = response.data.map((item) => ({
              ...item,
              val: JSON.parse(item.val),
            }));
            console.log("getRefs refs", refs);
            resolveMe(refs);
          } else {
            console.log("Error: No ref data found - response.data:", response.data);
            resolveMe([]); // Résoudre avec un tableau vide au lieu de laisser la promise en suspens
          }
          //return response.data;
        })
        .catch((error) => {
          console.log(error);
          alert("Error: getRefs failed");
          rejectMe(error);
        });
    });

    return prom;
  }
  mergeData(dataValue, refsDataOrigin, order) {
    // Vérifier que refsDataOrigin existe et est un tableau
    if (!refsDataOrigin || !Array.isArray(refsDataOrigin) || refsDataOrigin.length === 0) {
      console.log("mergeData: refsDataOrigin is empty or invalid, returning empty array");
      return [];
    }
    
    let refsData = JSON.parse(JSON.stringify(refsDataOrigin));
    for (let i = 0; i < refsData.length; i++) {
      const val = refsData[i].val.refData;
      for (let j = 0; j < val.length; j++) {
        forEach(entries(val[j]), ([key, value]) => {
          if (typeof value === "string" && value.includes("data.")) {
            refsData[i].val.refData[j][key] = dataValue[value.substring(5)];
          } 
        });
      }
      if (i === refsData.length - 1) {
        return refsData.sort((a, b) => a.order - b.order);
      }
    }
  }
  
}
